import { useCallback, useEffect, useState } from "react";
import { FileText, PenLine, Search } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Empty } from "@/components/Common";
import { openDdt } from "@/components/warehouse/MovementsTab";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const Signed = ({ d }) => d.signed_at
  ? <span className="inline-flex items-center gap-1 bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-800" data-testid={`ddt-signed-${d.id}`}><PenLine className="h-3 w-3" />Firmato da {d.signed_by} · {d.signed_label}</span>
  : d.to_label?.startsWith("Tecnico") ? <span className="bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800" data-testid={`ddt-unsigned-${d.id}`}>Da firmare in app</span> : <span className="text-xs text-muted-foreground">—</span>;

export const DdtTab = () => {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const load = useCallback((text) => api.get("/warehouse/ddt", { params: { q: text || undefined } }).then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { const t = setTimeout(() => load(q), 250); return () => clearTimeout(t); }, [q, load]);
  return (
    <div data-testid="ddt-tab">
      <div className="relative mb-3 max-w-md">
        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input className="pl-9" placeholder="Cerca per numero DDT, tecnico o magazzino…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="ddt-search-input" />
      </div>
      {rows && rows.length === 0 ? <Empty text="Nessun DDT emesso" testId="ddt-empty" /> : (
        <div className="overflow-x-auto border bg-white">
          <Table>
            <TableHeader><TableRow className="bg-muted/50"><TableHead>N.</TableHead><TableHead>Data</TableHead><TableHead>Da</TableHead><TableHead>Destinatario</TableHead><TableHead>Articoli</TableHead><TableHead>Firma</TableHead><TableHead /></TableRow></TableHeader>
            <TableBody>
              {(rows || []).map((d) => (
                <TableRow key={d.id} data-testid={`ddt-row-${d.id}`}>
                  <TableCell className="font-mono font-semibold">{d.number}</TableCell>
                  <TableCell className="whitespace-nowrap font-mono text-xs">{fmtDateTime(d.created_at)}</TableCell>
                  <TableCell className="text-xs">{d.from_name}</TableCell>
                  <TableCell className="text-sm">{d.to_label}<div className="text-xs text-muted-foreground">{d.to_name}</div></TableCell>
                  <TableCell className="text-xs">{d.lines.map((l) => `${l.code} ${l.qty}`).join(" · ")}</TableCell>
                  <TableCell><Signed d={d} /></TableCell>
                  <TableCell><Button size="sm" variant="outline" onClick={() => openDdt(d.id)} data-testid={`ddt-print-${d.id}`}><FileText className="mr-1 h-4 w-4" />Stampa</Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
